module.exports = __webpack_public_path__ + "img/shop-qiye.afd23419.png";